import script from "./StoreCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreCreate.vue?vue&type=script&setup=true&lang=js"

import "./StoreCreate.vue?vue&type=style&index=0&id=2213d70c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2213d70c"]])

export default __exports__